const BACKEND = process.env.REACT_APP_BACKEND_URL;

function getHeaders(token) {
  const h = { "Content-Type": "application/json" };
  if (token) h["Authorization"] = `Bearer ${token}`;
  return h;
}

export async function apiRegister(name, email, password) {
  const res = await fetch(`${BACKEND}/api/auth/register`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ name, email, password }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Registrazione fallita");
  }
  return res.json();
}

export async function apiLogin(email, password) {
  const res = await fetch(`${BACKEND}/api/auth/login`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Login fallito");
  }
  return res.json();
}

export async function apiGetMe(token) {
  const res = await fetch(`${BACKEND}/api/auth/me`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Non autenticato");
  return res.json();
}

export async function apiSetAccountType(token, accountType) {
  const res = await fetch(`${BACKEND}/api/auth/account-type?account_type=${accountType}`, {
    method: "PUT",
    headers: getHeaders(token),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

// Profiles
export async function apiCreateProfile(token, formData) {
  const res = await fetch(`${BACKEND}/api/profiles`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Errore creazione profilo");
  }
  return res.json();
}

export async function apiGetProfiles(token) {
  const res = await fetch(`${BACKEND}/api/profiles`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiGetProfile(token, profileId) {
  const res = await fetch(`${BACKEND}/api/profiles/${profileId}`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Profilo non trovato");
  return res.json();
}

// Chat
export async function apiGetChatHistory(token, profileId) {
  const res = await fetch(`${BACKEND}/api/chat/${profileId}`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiSendMessage(token, profileId, message) {
  const res = await fetch(`${BACKEND}/api/chat/${profileId}`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify({ message }),
  });
  if (!res.ok) throw new Error("Errore invio messaggio");
  return res.json();
}

// Diary
export async function apiGetDiary(token) {
  const res = await fetch(`${BACKEND}/api/diary`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiCreateDiaryEntry(token, data) {
  const res = await fetch(`${BACKEND}/api/diary`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiDeleteDiaryEntry(token, entryId) {
  const res = await fetch(`${BACKEND}/api/diary/${entryId}`, {
    method: "DELETE",
    headers: getHeaders(token),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

// Admin
export async function apiAdminLogin(username, password) {
  const res = await fetch(`${BACKEND}/api/admin/login`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Login admin fallito");
  }
  return res.json();
}

function adminHeaders() {
  const token = localStorage.getItem("admin_token");
  const h = { "Content-Type": "application/json" };
  if (token) h["Authorization"] = `Bearer ${token}`;
  return h;
}

export async function apiAdminStats() {
  const res = await fetch(`${BACKEND}/api/admin/stats`, { headers: adminHeaders() });
  if (!res.ok) throw new Error("Non autorizzato");
  return res.json();
}

export async function apiAdminUsers(skip = 0, limit = 50) {
  const res = await fetch(`${BACKEND}/api/admin/users?skip=${skip}&limit=${limit}`, { headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiAdminUserDetail(userId) {
  const res = await fetch(`${BACKEND}/api/admin/users/${userId}`, { headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiAdminToggleUser(userId) {
  const res = await fetch(`${BACKEND}/api/admin/users/${userId}/toggle`, { method: "PUT", headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiAdminDeleteUser(userId) {
  const res = await fetch(`${BACKEND}/api/admin/users/${userId}`, { method: "DELETE", headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiAdminProfiles(skip = 0, limit = 50) {
  const res = await fetch(`${BACKEND}/api/admin/profiles?skip=${skip}&limit=${limit}`, { headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiAdminDeleteProfile(profileId) {
  const res = await fetch(`${BACKEND}/api/admin/profiles/${profileId}`, { method: "DELETE", headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiAdminChats(skip = 0, limit = 50) {
  const res = await fetch(`${BACKEND}/api/admin/chats?skip=${skip}&limit=${limit}`, { headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiAdminChatMessages(profileId) {
  const res = await fetch(`${BACKEND}/api/admin/chats/${profileId}`, { headers: adminHeaders() });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

// Voice
export async function apiCloneVoice(token, profileId) {
  const res = await fetch(`${BACKEND}/api/voice/clone/${profileId}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch { data = {}; }
  if (!res.ok) {
    throw new Error(data.detail || "Errore clonazione voce");
  }
  return data;
}

export async function apiTextToSpeech(token, profileId, text) {
  const res = await fetch(`${BACKEND}/api/voice/tts/${profileId}`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify({ text }),
  });
  const raw = await res.text();
  let data;
  try { data = JSON.parse(raw); } catch { data = {}; }
  if (!res.ok) throw new Error(data.detail || "Errore generazione voce");
  return data;
}

// Settings — Guardian
export async function apiGetGuardian(token) {
  const res = await fetch(`${BACKEND}/api/settings/guardian`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiSetGuardian(token, data) {
  const res = await fetch(`${BACKEND}/api/settings/guardian`, {
    method: "PUT", headers: getHeaders(token), body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiRemoveGuardian(token) {
  const res = await fetch(`${BACKEND}/api/settings/guardian`, {
    method: "DELETE", headers: getHeaders(token),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

// Settings — Privacy
export async function apiGetPrivacy(token) {
  const res = await fetch(`${BACKEND}/api/settings/privacy`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiUpdatePrivacy(token, data) {
  const res = await fetch(`${BACKEND}/api/settings/privacy`, {
    method: "PUT", headers: getHeaders(token), body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

// Settings — Export
export async function apiExportData(token) {
  const res = await fetch(`${BACKEND}/api/settings/export`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

// Settings — Delete Account
export async function apiDeleteAccount(token) {
  const res = await fetch(`${BACKEND}/api/settings/account`, {
    method: "DELETE", headers: getHeaders(token),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

// Personality
export async function apiGetPersonality(token, profileId) {
  const res = await fetch(`${BACKEND}/api/profiles/${profileId}/personality`, { headers: getHeaders(token) });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

export async function apiUpdatePersonality(token, profileId, data) {
  const res = await fetch(`${BACKEND}/api/profiles/${profileId}/personality`, {
    method: "PUT", headers: getHeaders(token), body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Errore");
  return res.json();
}

